"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _immutable = _interopRequireDefault(require("immutable"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UIFolderNav = _interopRequireDefault(require("UIComponents/nav/UIFolderNav"));

var _UIFolderNavItem = _interopRequireDefault(require("UIComponents/nav/UIFolderNavItem"));

var _FoldersAndFiles = require("FileManagerCore/utils/FoldersAndFiles");

var FolderTree =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(FolderTree, _Component);

  function FolderTree(props) {
    var _this;

    (0, _classCallCheck2.default)(this, FolderTree);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FolderTree).call(this, props));
    _this.renderFolder = _this.renderFolder.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleHomeClick = _this.handleHomeClick.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(FolderTree, [{
    key: "getIcon",
    value: function getIcon(_ref) {
      var open = _ref.open,
          className = _ref.className,
          children = _ref.children;
      var icon = children && open ? 'folderOpen' : 'folder';
      return _react.default.createElement(_UIIcon.default, {
        className: (0, _classNames.default)('private-folder-nav-item__icon', className),
        name: icon
      });
    }
  }, {
    key: "getFolder",
    value: function getFolder(id) {
      var folders = this.props.folders;
      return folders.find(function (folder) {
        return folder.get('id') === id;
      });
    }
  }, {
    key: "getSelectedFolder",
    value: function getSelectedFolder() {
      var selectedFolder = this.props.selectedFolder;
      return selectedFolder || (0, _FoldersAndFiles.getHomeFolder)();
    }
  }, {
    key: "handleHomeClick",
    value: function handleHomeClick() {
      var onSelect = this.props.onSelect;
      onSelect((0, _FoldersAndFiles.getHomeFolder)());
    }
  }, {
    key: "renderFolder",
    value: function renderFolder(folder) {
      var _this2 = this;

      var _this$props = this.props,
          onSelect = _this$props.onSelect,
          ancestors = _this$props.ancestors,
          exclusions = _this$props.exclusions;
      var selectedFolder = this.getSelectedFolder();
      var children = folder.children;

      var handleClick = function handleClick() {
        onSelect(_this2.getFolder(folder.id));
      };

      if (exclusions.contains(folder.id)) {
        return null;
      }

      return _react.default.createElement(_UIFolderNavItem.default, {
        key: folder.id,
        value: folder.id,
        title: folder.name,
        active: selectedFolder.get('id') === folder.id,
        defaultOpen: ancestors.includes(folder.id) || selectedFolder.get('id') === folder.id,
        onClick: handleClick,
        iconLeft: this.getIcon
      }, children && children.length > 0 && this.renderChildren(children));
    }
  }, {
    key: "renderChildren",
    value: function renderChildren(children) {
      return children.map(this.renderFolder);
    }
  }, {
    key: "render",
    value: function render() {
      var tree = this.props.tree;
      var selectedFolder = this.getSelectedFolder();
      return _react.default.createElement(_UIFolderNav.default, null, _react.default.createElement(_UIFolderNavItem.default, {
        open: true,
        active: selectedFolder === (0, _FoldersAndFiles.getHomeFolder)(),
        title: tree.name,
        onClick: this.handleHomeClick
      }, this.renderChildren(tree.children)));
    }
  }]);
  return FolderTree;
}(_react.Component);

exports.default = FolderTree;
FolderTree.propTypes = {
  ancestors: _react.PropTypes.instanceOf(_immutable.default.Set).isRequired,
  exclusions: _react.PropTypes.instanceOf(_immutable.default.Set).isRequired,
  onSelect: _react.PropTypes.func.isRequired,
  selectedFolder: _react.PropTypes.instanceOf(_immutable.default.Map),
  // POJO for performance reasons and to more easily support references
  tree: _react.PropTypes.object.isRequired,
  folders: _react.PropTypes.instanceOf(_immutable.default.List).isRequired
};
FolderTree.defaultProps = {
  exclusions: new _immutable.default.Set()
};
module.exports = exports.default;